// Test version via Expo Go until the store launch (1 February 2027).
export const EXPO = {
  url: "exp://u.expo.dev/0d2f8b69-e685-4cea-8665-6c7066a92192/group/1ebf9909-1cc7-4427-885a-4b7108d38ada",
  ios: "https://apps.apple.com/app/expo-go/id982107779",
  android: "https://play.google.com/store/apps/details?id=host.exp.exponent",
};

export const SOCIAL_LINKS = [
  { key: "bluesky", label: "Bluesky", url: "https://bsky.app/profile/gratangen.bsky.social" },
  { key: "x", label: "X", url: "https://x.com/Trollfossjakten" },
  { key: "tiktok", label: "TikTok", url: "https://www.tiktok.com/@trollfossjakten" },
  { key: "youtube", label: "YouTube", url: "https://www.youtube.com/@Trollfossjakten" },
  { key: "instagram", label: "Instagram", url: "https://www.instagram.com/trollfossjakten/" },
  { key: "facebook", label: "Facebook", url: "https://www.facebook.com/profile.php?id=61590413927230" },
  { key: "threads", label: "Threads", url: "https://www.threads.com/@trollfossjakten" },
  { key: "pinterest", label: "Pinterest", url: "https://no.pinterest.com/lavangen/" },
];

export const COMPANY = {
  name: "ATE ARCTIC SALES & MARKETING",
  orgNr: "936314392",
  email: "martinsate@gmail.com",
  registryUrl: "https://virksomhet.brreg.no/nb/oppslag/enheter/936314392",
};

export const SUPPORTERS = [
  { key: "lavangen", name: "Loabága suohkan – Lavangen kommune", url: "https://www.lavangen.kommune.no/", logo: "/brand/lavangen-kommune.webp", height: "h-10 md:h-11" },
  { key: "kupi", name: "Kupi.no", url: "https://kupi.no?ref=d8e1a707", logo: "/brand/kupi.webp", height: "h-8 md:h-10" },
  { key: "kippmaster", name: "KippMaster", url: "https://kipp.no/", logo: "/brand/kippmaster.webp", height: "h-7 md:h-9" },
  { key: "neurintl", name: "NeurIntl – AI Hypnotherapist", url: "https://neurintl.com/ai-hypnotherapist", logo: "/brand/neurintl.webp", height: "h-9 md:h-11" },
  { key: "zigi", name: "Zigi AI", url: "https://zigiai.com/", logo: "/brand/zigi.webp", height: "h-10 md:h-12" },
  { key: "fjellkysten", name: "Fjellkysten Gjestehus", url: "https://www.fjellkysten.no/en/", logo: "/brand/fjellkysten.webp", height: "h-11 md:h-12" },
  { key: "midnattsoltrappa", name: "Midnattsoltrappa", url: "https://www.midnattsoltrappa.no/", logo: "/brand/midnattsoltrappa.webp", height: "h-14 md:h-16" },
  { key: "aagard", name: "Aa gård – Lavangen", url: "https://www.aagaard-lavangen.no/nb/", logo: "/brand/aagard.webp", height: "h-12 md:h-14" },
  { key: "salaks", name: "Salaks", url: "https://salaks.no/", logo: "/brand/salaks.webp", height: "h-7 md:h-8" },
];

